import { render } from "./message-msg-box.vue?vue&type=template&id=a8e08556&scoped=true&ts=true"
import script from "./message-msg-box.vue?vue&type=script&lang=ts"
export * from "./message-msg-box.vue?vue&type=script&lang=ts"

import "./message-msg-box.vue?vue&type=style&index=0&id=a8e08556&lang=scss&scoped=true"

import exportComponent from "D:\\project\\haocai\\h5\\kousai-group\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8e08556"]])

export default __exports__